<div class="content">
  <ui-product-card-core-skeleton [displayListView]="displayListView()"></ui-product-card-core-skeleton>

  @if (displayListView()) {
    <div class="col-prices">
      <div class="wrapper-prices">
        <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
      </div>
    </div>
  }
</div>